import script from "./MatchesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MatchesModal.vue?vue&type=script&lang=ts&setup=true"

import "./MatchesModal.vue?vue&type=style&index=0&id=51ca7907&lang=scss"

const __exports__ = script;

export default __exports__